module.exports = __webpack_public_path__ + "img/Redeéo_80X30.32b6c07c.png";